import IconService from "icon-sdk-js";
import { IconConverter, IconUtil, HttpProvider } from "icon-sdk-js";
import logger from "../utils/logger.ts";

// Import the local package using dynamic import
let AppIcx;
const loadAppIcx = async () => {
  if (!AppIcx) {
    const module = await import("../packages/hw-app-icx/lib/Icx.js");
    AppIcx = module.default;
  }
  return AppIcx;
};

// const {
//   IconAmount,
//   HttpProvider,
//   IconWallet,
//   IconBuilder,
//   SignedTransaction,
//   IconUtil,
// } = require("icon-sdk-js");

// const AppIcx = require("../packages/hw-app-icx/lib/Icx.js").default;

const { CallBuilder } = IconService.IconBuilder;

const GANGSTA_SCORE = import.meta.env.VITE_GANGSTA_SCORE;
const GBET_SCORE = import.meta.env.VITE_GBET_SCORE;
const SKILL_SCORE = import.meta.env.VITE_SKILL_SCORE;
const MARKETPLACE_SCORE = import.meta.env.VITE_MARKETPLACE_SCORE;
const WALLET_NETWORK = import.meta.env.VITE_WALLET_URL;
const NETWORK_ID = import.meta.env.VITE_NETWORK_ID;

const provider = new HttpProvider(WALLET_NETWORK);

const callBuilder = new CallBuilder();
const iconService = new IconService(provider);

export const signTransaction = async (
  walletPath,
  transport,
  address,
  nftCount
) => {
  const txBuilder = new IconService.IconBuilder.CallTransactionBuilder();
  const txData = txBuilder
    .from(address)
    .to(GANGSTA_SCORE)
    .nid(NETWORK_ID)
    .timestamp(new Date().getTime() * 1000)
    .stepLimit(IconConverter.toBigNumber(40000000))
    .version(IconConverter.toBigNumber(3))
    .method("request_character_creation")
    .params({
      nft_count: nftCount,
    })
    .build();

  const rawTransaction = IconConverter.toRawTransaction(txData);
  const hashKey = IconUtil.generateHashKey(rawTransaction);
      logger.debug("Ledger transaction signing", { hashKey, transport });
  const AppIcxClass = await loadAppIcx();
  const icx = new AppIcxClass(transport);
  const { signedRawTxBase64 } = await icx.signTransaction(walletPath, hashKey);
      logger.debug("Signed transaction base64", { signedRawTxBase64 });
  rawTransaction.signature = signedRawTxBase64;
      logger.debug("Raw transaction", { rawTransaction });


      logger.debug("Signed transaction completed", { signedRawTxBase64 });
  try {
    const res = await iconService.sendTransaction({ getProperties: () => rawTransaction, getSignature: () => signedRawTxBase64 }).execute();
    return res;
  } catch (err) {
    logger.walletError('signTransaction', err, { walletType: 'LEDGER' });
    return false;
  }

  // return {
  //   getProperties: () => rawTransaction,
  //   getSignature: () => signedRawTxBase64,
  // };
};
